import { Platform } from 'react-native';

export enum Screens {
  HOME_ROOT = 'HOME_ROOT',
  HEALTH_ROOT = 'HEALTH_ROOT',
  CARE_ROOT = 'CARE_ROOT',
  BILLING_ROOT = 'BILLING_ROOT',
  MESSAGE_ROOT = 'MESSAGE_ROOT',

  SPLASH = 'Splash',
  APP_UPDATE = 'APP_UPDATE',

  /** Messaging */
  MESSAGES = 'MESSAGES',
  MESSAGES_DETAIL = 'MESSAGES_DETAIL',
  MESSAGES_COMPOSE = 'MESSAGES_COMPOSE',
  MESSAGE_COMPOSE_FIND_PROVIDER = 'MESSAGE_COMPOSE_FIND_PROVIDER',
  MESSAGE_COMPOSE_POOL_SELECT = 'MESSAGE_COMPOSE_POOL_SELECT',

  NETWORK_LOCK_SCREEN = 'dfd.NetworkLock',

  TRANSMIT_LANDING = 'TRANSMIT_LANDING',

  /** Notifications */
  NOTIFICATIONS = 'NOTIFICATIONS',
  NOTIFICATIONS_HIPAA = 'NOTIFICATIONS_HIPAA',
  NOTIFICATIONS_TCPA = 'NOTIFICATIONS_TCPA',
  NOTIFICATIONS_OPT_OUT = 'NOTIFICATIONS_OPT_OUT',

  CLOSE_HEALTH_ADVISORY = 'CLOSE_HEALTH_ADVISORY',

  /** Booking */
  PAST_APPOINTMENTS = 'BOOKING_PAST_APPOINTMENTS',

  /** Updates */
  UPDATES = 'UPDATES',

  /** Help */
  HELP = 'HELP',

  /** Survey */
  SURVEY = 'SURVEY',

  /** TOC Screen */
  TERMS_AND_CONDITIONS = 'TermsAndConditions',

  /** Telehealth Amwell */
  WAITING_ROOM = 'TelehealthWaitingRoom'
}

export const PLATFORM_TOKEN_TYPE =
  Platform.select({
    android: 'FCM',
    ios: 'APN'
  }) || '';
